/* eslint-disable import/no-anonymous-default-export */
import {
    SET_APP_RR_REPORTING_STATUS,
    SET_APP_RR_FCST,
    SET_APP_RR_LIKELIHOOD,
    SET_APP_RR_INC_WFO,
    SET_APP_RR_FILTER_ITEM,
    SET_APP_RR_FILTER_REPORTING_STATUS,
    SET_APP_RR_FILTER_FCST,
    SET_APP_RR_FILTER_LIKELIHOOD,
    SET_APP_RR_FILTER_INC_WFO,
    SET_APP_RR_CHECK_NULL_FILTERS,
} from '../actions/_types'

const initialState = {
    fcst: {},
    likelihood: {},
    reporting: {},
    wfo: true,
    appRptFilter: {
        reporting: '',
        fcst: '',
        likelihood: '',
        wfo: true,
        run: false,
        refresh: false,
    },
    checkNullFilters: false,  
}

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_APP_RR_REPORTING_STATUS:
             return { ...state, reporting: action.payload };
        case SET_APP_RR_FCST:
             return { ...state, fcst: action.payload };
        case SET_APP_RR_LIKELIHOOD:
             return { ...state, likelihood: action.payload };            
        case SET_APP_RR_INC_WFO:
             return { ...state, wfo: action.payload };
        case SET_APP_RR_FILTER_ITEM:
            return { ...state, appRptFilter: action.payload};
        case SET_APP_RR_FILTER_REPORTING_STATUS:
            return { ...state, appRptFilter: {...state.appRptFilter, reporting: action.payload}}
        case SET_APP_RR_FILTER_FCST:
            return { ...state, appRptFilter: {...state.appRptFilter, fcst: action.payload}}
        case SET_APP_RR_FILTER_LIKELIHOOD:
            return { ...state, appRptFilter: {...state.appRptFilter, likelihood: action.payload}}            
        case SET_APP_RR_FILTER_INC_WFO:
            return { ...state, appRptFilter: {...state.appRptFilter, wfo: action.payload}}
        case SET_APP_RR_CHECK_NULL_FILTERS:
            return { ...state, checkNullFilters: action.payload}
        default:
            return state
    }
};            